"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterLink = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
exports.RouterLink = react_1.forwardRef(function RouterLink(_a, ref) {
    var { Component, href = "" } = _a, props = tslib_1.__rest(_a, ["Component", "href"]);
    const Link = react_1.forwardRef(function Link(_a, ref) {
        var { 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        navigate } = _a, // Do not inject this props provided by router-dom
        props = tslib_1.__rest(_a, ["navigate"]);
        return jsx_runtime_1.jsx(Component, Object.assign({}, Object.assign(Object.assign({}, props), { ref })), void 0);
    });
    const linkProps = Object.assign(Object.assign({}, props), { to: href, component: Link });
    return jsx_runtime_1.jsx(react_router_dom_1.Link, Object.assign({}, linkProps, { ref: ref }), void 0);
});
//# sourceMappingURL=RouterLink.js.map